import request from '@/utils/request'

// 查询码上办-威海市市长质量奖申报列表
export function listWhszzljsb(query) {
  return request({
    url: '/web/whszzljsb/list',
    method: 'get',
    params: query
  })
}

// 查询码上办-威海市市长质量奖申报详细
export function getWhszzljsb(whszzljsbId) {
  return request({
    url: '/web/whszzljsb/getInfo/' + whszzljsbId,
    method: 'get'
  })
}

// 新增码上办-威海市市长质量奖申报
export function addWhszzljsb(data) {
  return request({
    url: '/web/whszzljsb/add',
    method: 'post',
    data: data
  })
}

// 修改码上办-威海市市长质量奖申报
export function updateWhszzljsb(data) {
  return request({
    url: '/web/whszzljsb/edit',
    method: 'post',
    data: data
  })
}

// 删除码上办-威海市市长质量奖申报
export function delWhszzljsb(whszzljsbId) {
  return request({
    url: '/web/whszzljsb/delete/' + whszzljsbId,
    method: 'post'
  })
}

// 审核码上办-威海市市长质量奖申报
export function auditWhszzljsb(data) {
  return request({
    url: '/web/whszzljsb/audit',
    method: 'post',
    data: data
  })
}
